import { createSlice } from "@reduxjs/toolkit";

const inspectionSlice = createSlice({
  name: "inspection",
  initialState: [],
  reducers: {
    inspectionAdded(state, action) {
      return action.payload;
    },
    inspectionSpecificAdded(state, action) {
      const inspection = action.payload;
      const specificInspectionIndex = state.findIndex(item => item.id === inspection.id);
      if (specificInspectionIndex === -1) {
        state.push(inspection);
      } else {
        state[specificInspectionIndex] = inspection;
      }
      return state;
    },
    inspectionFileAdd(state, action) {
      const file = action.payload.file;
      const inspectionId = action.payload.inspectionId;

      const inspIndex = state.findIndex(item => item.id === inspectionId);
      if (inspIndex !== -1) {
        if (Array.isArray(state[inspIndex].images)) {
          state[inspIndex].images.push(file);
        } else {
          state[inspIndex].images = [file];
        }
      }
    },
    inspectionFileDelete(state, action) {
      const file = action.payload.file;
      const inspectionId = action.payload.inspectionId;

      const inspection = state.find(item => item.id === inspectionId);
      if (inspection?.images) {
        inspection.images = inspection.images.filter(image => image.id !== file.id);
      }
    },
    updateInspectionItemState(state, action) {
      const inspection = action.payload;
      const specificInspectionIndex = state.findIndex(item => item.id === inspection.id);
      if (specificInspectionIndex !== -1) {
        state[specificInspectionIndex] = inspection;
      }
      return state;
    },
  },
});

export const {
  inspectionAdded,
  inspectionSpecificAdded,
  inspectionFileAdd,
  inspectionFileDelete,
  updateInspectionItemState,
} = inspectionSlice.actions;
export default inspectionSlice.reducer;
